﻿export default class Comment {
  constructor (obj) {
    if (obj) {
      obj && Object.assign(this, obj)
      return
    }

    this.ID = 0
    this.NewsRef = 0
    this.Contents = ''
    this.UserIDRef = 0
    this.UserName = ''
    this.UserInitials = 'NN'
    this.Created = ''
    this.Deleted = false
  }
}
